// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__36LRq","range":"MonthRangeSwitch_range__1KXBa","disabled":"MonthRangeSwitch_disabled__1Rb6V"};